import { NgClass } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LibSharedCommonModule } from '@solvace/common';
import { SvcBtnIconComponent } from './svc-btn-icon.component';

@NgModule({
  declarations: [
    SvcBtnIconComponent
  ],
  imports: [
    LibSharedCommonModule,
    MatProgressSpinnerModule,
    MatIconModule,
    NgClass,
  ],
  exports: [
    SvcBtnIconComponent
  ]
})
export class SvcBtnIconModule { }
